import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Layout, Menu } from "antd";
import trans, { isRTL } from "../../utils";

import { Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { webSocketManager } from "../../Sockets/WebSocketManager";
import { toast } from "react-toastify";
import HeaderDropdown from "../Header/HeaderDropdown";
import Loader from "../Helpers/Loader/Loader";
import { filtrationcontext } from "../../context/Filtercontext";
import { popupcontext } from "../../context/Popupscontext";
import LiveEvents from "../LiveEvents/LiveEvents";
import SideEvents from "../LiveEvents/SideEvents";
import { useGetNotificationsCountQuery } from "../../Redux/service/Notifications/NewNotifications";
import { useSelector } from "react-redux";
import { sidebarcontext } from "../../context/Sidebarcontext";
import LiveTasks from "../LiveEvents/LiveTasks";
import { socketIOManager } from "../../Sockets/SocketIOManager";
import { MergedKeyToRoute, MergedSidebar } from "../../utils/Sidebar/sidebar";
import DashboardNavigator from "../Dashboard/DashboardNavigator";
import { getData } from "../../utils/IndexedDB";
const { Header, Sider, Content } = Layout;

const NewMainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [menuOpenKeys, setMenuOpenKeys] = useState([]);
  let { loader } = useContext(filtrationcontext);
  let { isFullScreen, setIsFullScreen, options, setOptions, handleShow } =
    useContext(popupcontext);
  let { isSideOpen, setIsSideOpen } = useContext(sidebarcontext);
  let { data, refetch } = useGetNotificationsCountQuery();
  const dropdownRef = useRef(null);
  let inf = useSelector((state) => state.users.user);
  const auth = useSelector((state) => state.users.auth);
  const offlineMode = useSelector((i) => i.users.offlineMode);
  const siderStyle = {
    overflow: "auto",
    height: "100vh",
    position: "sticky",
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: "8px",
    scrollbarGutter: "stable",
  };

  let navigate = useNavigate();
  const location = useLocation();

  const isDashboardRoute =
    location.pathname === "/" ||
    location.pathname === "/dashboard" ||
    location.pathname.startsWith("/dashboard/");

  useEffect(() => {
    if (inf?.id) {
      try {
        webSocketManager.connect();
        socketIOManager.connectMain(localStorage.getItem("token"));
        socketIOManager.connectTest(localStorage.getItem("token"));
      } catch (error) {
        toast.info(trans("Session Expired"), {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        });
        localStorage.removeItem("token");
        navigate("/signin");
      }
    }
  }, [navigate]);
  const routeToKey = Object.entries(MergedKeyToRoute).reduce(
    (acc, [key, path]) => {
      acc[path] = key;
      return acc;
    },
    {},
  );

  // Sidebar keys for dashboard → moduleKeys that grant access
  const DASHBOARD_KEY_TO_MODULE_KEYS = {
    dashboard: ["DASHBOARD"],
    dashboardqaqc: ["DASHBOARDQAQC"],
    dashboardfs: ["FSMDASHBOARD", "DASHBOARDFS"],
    dashboards: ["CONSULTANTDASHBOARD"],
    analytics: ["ANALYTICS"],
    // Sidebar keys without a matching backend permission name,
    // granted through an existing moduleKey instead
    "recurring-planner": ["FIELD_TASKS"],
    "call-center": ["CALLCENTER"],
    dispatcher: ["DISPATCH"],
  };

  // Priority: FSM → QA → Consultant → Tracking (first one user has access to)
  const DASHBOARD_PATH_PRIORITY = [
    { path: "/dashboard/fsm", keys: ["FSMDASHBOARD", "DASHBOARDFS"] },
    { path: "/dashboard/qa", keys: ["DASHBOARDQAQC"] },
    { path: "/dashboard/consultant", keys: ["CONSULTANTDASHBOARD"] },
    { path: "/dashboard", keys: ["DASHBOARD"] },
  ];

  const getFirstDashboardPath = () => {
    for (const { path, keys } of DASHBOARD_PATH_PRIORITY) {
      const hasAccess = permissions.some(
        (p) => keys.includes(p.moduleKey) && p.actions?.view !== false,
      );
      if (hasAccess) return path;
    }
    return "/dashboard";
  };

  const permissions = Array.isArray(auth?.permissions) ? auth.permissions : [];
  const basePermissionNames = permissions
    .map((perm) => perm?.name)
    .filter(Boolean);
  const permissionNames = [
    ...basePermissionNames,
    "setup.account",
    // "Snag List" has no backend permission name of its own (it's part of the
    // SNAG resource), so derive its key when SNAG is present. This keeps it
    // visible next to the gated "Snag Report" child — otherwise an explicitly
    // matched sibling hides children that rely on the all-children fallback.
    ...(basePermissionNames.includes("snag") ? ["snag-list"] : []),
  ];
  const Offlinemodules = useSelector((state) => state.users.offlineModules);
  const configId = useSelector((state) => state.users.configId);
  console.log("Offline Modules from Redux:", Offlinemodules, configId);
  const hasPermissionForSidebarKey = (itemKey) => {
    // Admins see everything
    if (auth?.administrator || inf?.administrator) return true;

    // Single "Dashboard" button: show if user has any dashboard permission
    if (itemKey === "dashboard") {
      return DASHBOARD_PATH_PRIORITY.some(({ keys }) =>
        permissions.some(
          (p) => keys.includes(p.moduleKey) && p.actions?.view !== false,
        ),
      );
    }

    // Near Miss (Safety module): strictly driven by the NEAR_MISS permission.
    if (itemKey === "near-miss") {
      return permissionNames?.includes("near-miss");
    }

    const moduleKeys = DASHBOARD_KEY_TO_MODULE_KEYS[itemKey];
    if (moduleKeys) {
      return permissions.some(
        (p) => moduleKeys.includes(p.moduleKey) && p.actions?.view !== false,
      );
    }
    return permissionNames?.includes(itemKey);
  };

  // Move filteredItems calculation into useMemo to recalculate when dependencies change
  const filteredItems = useMemo(() => {
    const moduleKeyMap = {
      snag: "SNAG",
      "inspection-request": "IR",
    };

    const modulesSet = new Set(
      Offlinemodules?.modules?.map((i) => i.module) || [],
    );

    return MergedSidebar?.filter((item) => {
      if (!offlineMode) return true;

      // Setup is always allowed if offline flag is true
      if (item.key === "setup") {
        return item.offline === true;
      }

      const mappedModule = moduleKeyMap[item?.key];

      // If no mapping exists, check if the key itself is in modulesSet
      // OR allow items that don't need module mapping
      if (!mappedModule) {
        return item.offline === true; // Allow if marked offline, even without module mapping
      }

      return item.offline === true && modulesSet.has(mappedModule);
    })
      ?.map((item) => {
        const parentAllowed = hasPermissionForSidebarKey(item.key);

        if (item.children) {
          const allowedChildren = item.children?.filter((child) => {
            const childAllowed = hasPermissionForSidebarKey(child.key);

            if (offlineMode) {
              if (item.key === "setup") {
                return childAllowed && child.offline === true;
              }

              const mappedModule = moduleKeyMap[child?.key];

              // If no mapping, allow if marked offline
              if (!mappedModule) {
                return childAllowed && child.offline === true;
              }

              return (
                childAllowed &&
                child.offline === true &&
                modulesSet.has(mappedModule)
              );
            }

            return childAllowed;
          });

          if (parentAllowed) {
            return {
              ...item,
              children:
                allowedChildren?.length > 0 ? allowedChildren : item.children,
            };
          }

          if (allowedChildren?.length > 0) {
            return {
              ...item,
              children: allowedChildren,
            };
          }

          return null;
        }

        if (offlineMode) {
          const mappedModule = moduleKeyMap[item?.key];

          // If no mapping, just check parent permission
          if (!mappedModule) {
            return parentAllowed ? item : null;
          }

          return parentAllowed && modulesSet.has(mappedModule) ? item : null;
        }

        return parentAllowed ? item : null;
      })
      .filter(Boolean);
  }, [
    Offlinemodules,
    offlineMode,
    MergedSidebar,
    permissions,
    permissionNames,
  ]);
  // Any dashboard route highlights the single Dashboard sidebar item
  const currentKey = isDashboardRoute
    ? "dashboard"
    : routeToKey[location.pathname] || undefined;

  const goFullScreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
      document.documentElement.msRequestFullscreen();
    }
    setIsFullScreen(true);
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullScreen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "F11") {
      event.preventDefault();
      isFullScreen ? exitFullScreen() : goFullScreen();
    }
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOptions(false);
    }
  };
  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    document.addEventListener("mousedown", handleClickOutside); // Listen for outside clicks

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFullScreen]);
  const events = useSelector((state) => state.webSocket.events);
  useEffect(() => {
    if (events) {
      refetch();
    }
  }, [events, refetch]);
  if (loader) {
    return (
      <div className="loader-container">
        <div className="loader">
          <Loader />
        </div>
      </div>
    );
  }
  return (
    <Layout dir={localStorage.getItem("lang") === "ar" ? "rtl" : "ltr"}>
      <Sider
        style={siderStyle}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={240}
        collapsedWidth={80}
      >
        <div className="px-4 py-3">
          <div className="sidebar-head flex-between mb-2">
            {!collapsed && (
              <div className="d-flex align-items-center">
                <div className="sidebar-logo mb-0 me-2">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/Lg-Logo.svg`}
                    alt="Logo"
                    style={{ width: 20, height: 20 }}
                  />
                </div>
                <div className="sidebar-head-title">Soft Sprint</div>
              </div>
            )}

            <div
              className={`head-arrow ${collapsed ? "text-center mt-2" : ""}`}
              style={{ transform: !collapsed && "translateX(16px)" }}
              role="button"
            >
              <Button
                type="text"
                icon={
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/New/Sidebar/${
                      isRTL
                        ? collapsed
                          ? "Collapse" // Reverse for Arabic
                          : "Expand"
                        : collapsed
                          ? "Expand"
                          : "Collapse"
                    }.svg`}
                    alt={
                      isRTL
                        ? collapsed
                          ? "Collapse"
                          : "Expand"
                        : collapsed
                          ? "Expand"
                          : "Collapse"
                    }
                  />
                }
                onClick={() => {
                  setCollapsed(!collapsed);
                  setIsSideOpen(!isSideOpen);
                }}
                style={{
                  fontSize: 16,
                  width: 32,
                  height: 32,
                  textAlign: collapsed ? "center" : "left",
                }}
              />
            </div>
          </div>

          {/*
    Optional logo section
    <div className="sidebar-logo mb-0">
      <img
        src={`${process.env.PUBLIC_URL}/assets/Lg-Logo.svg`}
        alt="Logo"
        style={{ width: 100, height: 100 }}
      />
    </div>
    */}
        </div>

        <div
          style={{
            flex: 1,
            overflowY: "auto",
            maxHeight: "calc(100vh - 88px)",
          }}
        >
          <Menu
            mode="inline"
            selectedKeys={currentKey ? [currentKey] : []}
            openKeys={menuOpenKeys}
            onOpenChange={setMenuOpenKeys}
            items={filteredItems}
            onClick={({ key }) => {
              if (key === "dashboard") {
                navigate(getFirstDashboardPath());
                return;
              }
              const path = MergedKeyToRoute[key];
              if (path) navigate(path);
            }}
          />
        </div>
      </Sider>
      <Layout>
        <Header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div className="flex-between w-100">
            <img
              src={`${process.env.PUBLIC_URL}/assets/loocet/SoftSprintLogoWhite.png`}
              alt="logo"
              style={{ width: "30px", height: "30px" }}
            />
            <div className="d-flex justify-content-between align-items-center mx-2">
              {isDashboardRoute && <DashboardNavigator />}
              <div
                className="notify position-relative"
                onClick={() => handleShow("notification")}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/dark/notifications.svg`}
                  alt="notification"
                />
                <div className="notify-count">
                  <p>{data?.count > 99 ? "99+" : data?.count}</p>
                </div>
              </div>
              <div
                className="screen-control mx-4"
                role="button"
                onClick={!isFullScreen ? goFullScreen : exitFullScreen}
              >
                <img
                  src={
                    !isFullScreen
                      ? `${process.env.PUBLIC_URL}/assets/dark/expand.svg`
                      : `${process.env.PUBLIC_URL}/assets/Minimize2.svg`
                  }
                  alt="expand"
                />
              </div>
              <div
                className="header-username"
                onClick={() => setOptions(!options)}
              >
                {inf?.name && <p className="text-capitalize">{inf?.name[0]}</p>}
                {options && <HeaderDropdown />}
              </div>
            </div>
          </div>
        </Header>
        <Content>
          <LiveEvents />
          <LiveTasks />
          <SideEvents />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default NewMainLayout;
